import { components } from 'react-select'
import { UatDataset } from '../../../../uat/types/uat-dataset.interface'
import { DropdownLibraryMenuListProps } from './dropdown-library-menu-list.props'

export const DropdownLibraryMenuList =
  (uat?: UatDataset) => (props: DropdownLibraryMenuListProps) => {
    return <components.MenuList {...props} innerProps={{ ...uat } as any} />
  }
